import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import useCopyText from 'hooks/useCopyText'
import { useEffect, useState } from 'react'
import bookingsApi from 'services/api/bookings'

import styles from './BookingPaymentInfoDialog.module.scss'

const DataRow = ({ label, value }) => {
  const copy = useCopyText()

  return (
    <div className={styles.dataRow}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>
        {value}
        <button onClick={() => copy(value)}>
          <CopyIcon />
        </button>
      </div>
    </div>
  )
}

const BookingPaymentInfoDialog = ({ onClose, paymentAccountId }) => {
  const [paymentInfo, setPaymentInfo] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    bookingsApi
      .unmaskBookingDetails({ paymentAccountId })
      .then(paymentInfo => {
        setPaymentInfo(paymentInfo)
        setIsErred(false)
      })
      .catch(() => {
        setIsErred(true)
      })

      .finally(() => {
        setIsLoading(false)
      })
  }, [paymentAccountId])

  return (
    <ConfirmationDialog
      title="Payment info"
      theme="blacklist"
      onClose={onClose}
      onConfirm={onClose}
      maxWidth={900}
    >
      {isLoading && <LoadingIndicator inline />}
      {isErred && <div>Something went wrong</div>}
      {!isLoading && !isErred && (
        <div className={styles.wrapper}>
          <div className={styles.row}>
            <p className={styles.rowTitle}>Guest info</p>
            <div className={styles.rowInner}>
              <DataRow label="First name" value={paymentInfo.firstName} />
              <DataRow label="Last name" value={paymentInfo.lastName} />
              <DataRow label="Email" value={paymentInfo.email} />
              <DataRow label="Phone" value={paymentInfo.phone} />
              <DataRow label="Country" value={paymentInfo.country} />
              <DataRow label="State" value={paymentInfo.state} />
              <DataRow label="City" value={paymentInfo.city} />
              <DataRow label="Street" value={paymentInfo.street} />
              <DataRow label="Address" value={paymentInfo.address} />
            </div>
          </div>
          <div className={styles.row}>
            <p className={styles.rowTitle}>Credit card info</p>
            <div className={styles.rowInner}>
              <DataRow label="Card number" value={paymentInfo.creditCard.pan} />
              <DataRow label="CVV" value={paymentInfo.creditCard.cvv} />
              <DataRow label="Cardholder name" value={paymentInfo.creditCard.holder} />
              <DataRow
                label="Expiration month"
                value={paymentInfo.creditCard.expirationMonth}
              />
              <DataRow
                label="Expiration year"
                value={paymentInfo.creditCard.expirationYear}
              />
            </div>
          </div>
        </div>
      )}
    </ConfirmationDialog>
  )
}

export default BookingPaymentInfoDialog
